/*
 * Public API Surface of icons
 */

export * from './lib/tesla.icons.service';
export * from './lib/tesla.icons.component';
export * from './lib/tesla.icons.module';
export * from './lib/nb.tesla.icons.module';
